require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-sitecore-javascript-developers.json") })
        }
      }, "path---posts-sitecore-javascript-developers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-sitecore-javascript-developers!./.cache/json/posts-sitecore-javascript-developers.json
// module id = 368
// module chunks = 231608221292675